import moment from 'moment';
import 'moment/locale/es';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ResponsiveContext } from '../../contexts/ResponsiveContext';
import Message from '../LoadingError/Error';
import Loading from '../LoadingError/Loading';

const Preorders = ({ preorders, loadingPreorders, preordersError }) => {
  moment.locale('es');

  const { is1000 } = useContext(ResponsiveContext);
  const handleTotal = (preorder) => {
    const addDecimals = (num) => {
      return (Math.round(num * 100) / 100).toFixed(2);
    };

    const itemsPrice = addDecimals(
      preorder.cartItems?.reduce(
        (acc, item) => acc + (item.price / 1.21) * item.qty,
        0
      )
    );
    const itemsTotalPrice = addDecimals(
      preorder.cartItems?.reduce((acc, item) => acc + item.price * item.qty, 0)
    );
    const shippingPrice = preorder.deliveryMethod
      ? preorder.deliveryMethod === 'tienda'
        ? 0
        : addDecimals(itemsPrice > 200 / 1.21 ? 0 : 5.95 / 1.21)
      : 0;
    const taxPrice = addDecimals(
      Number((0.21 * itemsPrice + 0.21 * shippingPrice).toFixed(2))
    );
    const totalPrice =
      preorder.deliveryMethod === 'domicilio'
        ? itemsPrice > 200 / 1.21
          ? Number(itemsTotalPrice).toFixed(2)
          : (Number(itemsTotalPrice) + Number(5.95)).toFixed(2)
        : Number(itemsTotalPrice).toFixed(2);

    preorder.itemsPrice = itemsPrice;
    preorder.shippingPrice = shippingPrice;
    preorder.taxPrice = taxPrice;
    preorder.totalPrice = totalPrice;
  };

  return (
    <div className=' d-flex justify-content-center align-items-center flex-column'>
      {loadingPreorders ? (
        <Loading />
      ) : preordersError ? (
        <Message variant='alert-danger'>{preordersError}</Message>
      ) : (
        <>
          {preorders.length === 0 ? (
            <div
              className={`col-12 alert alert-info text-center ${
                is1000 ? '' : 'mt-5'
              }`}
            >
              No tienes ningún pedido sin terminar
              <Link
                className='btn btn-success mx-2 px-3 py-2'
                to='/'
                style={{
                  fontSize: '12px',
                }}
              >
                EMPIEZA A COMPRAR
              </Link>
            </div>
          ) : (
            <div className={`table-responsive ${is1000 ? '' : 'mt-5'}`}>
              <table className='table'>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>FECHA</th>
                    <th>TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  {preorders.map((preorder) => (
                    <tr
                      className={`${
                        preorder.isPaid ? 'alert-success' : 'alert-danger'
                      }`}
                      key={preorder._id}
                    >
                      <td>
                        <a href={`/preorder/${preorder._id}`} className='link'>
                          {preorder._id.substr(-6, 6)}
                        </a>
                      </td>
                      <td>
                        {preorder.isPaid
                          ? moment(preorder.paidAt).calendar()
                          : moment(preorder.createdAt).calendar()}
                      </td>
                      <td>
                        {handleTotal(preorder)}
                        {preorder?.totalPrice.toString().replace('.', ',')}
                        {preorder?.totalPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? preorder?.totalPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Preorders;
